import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import type FileProviderItemViewState from '../store/schema/FileProviderItemViewState';
import updateFileProviderItems from './updateFileProviderItems';
import { action } from 'satcheljs/lib/legacy';

export default action('clearThenUpdateFileProviderItems')(function clearThenUpdateFileProviderItems(
    items: FileProviderItemViewState[],
    viewState: FilePickerPanelViewState,
    requestId: number
) {
    viewState.filePickerViewState.fileProviderItems = [];
    viewState.filePickerViewState.totalItemsCount = 0;
    viewState.filePickerViewState.selectedFileProviderItems = [];

    updateFileProviderItems(items, viewState, requestId);
});
